import { render } from "./PlayerArea.vue?vue&type=template&id=25542153&ts=true"
import script from "./PlayerArea.vue?vue&type=script&lang=ts"
export * from "./PlayerArea.vue?vue&type=script&lang=ts"

import "./PlayerArea.vue?vue&type=style&index=0&id=25542153&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__